import {Dispatch} from "redux";
import {TimezonesActionTypes, TimezonesAction} from "../../types/admins/timezones";
import axios from "axios";


export const getTimezonesData = (): any => {
    return async (dispatch: Dispatch<TimezonesAction>) => {
        try {
            dispatch({type: TimezonesActionTypes.FETCH_TIMEZONES_DATA});
            const response = await axios({
                method: 'get',
                url: `/api/timezones`,
                withCredentials: false
            });
            dispatch({type: TimezonesActionTypes.FETCH_TIMEZONES_DATA_SUCCESS, payload: response.data})
        } catch (error) {
            dispatch({type: TimezonesActionTypes.FETCH_TIMEZONES_DATA_ERROR, payload: 'Something wend wrong check Timezones action controller'});
        }
    }
}